import { min } from "lodash"

const daechiQrMapping = {
    "1": { min: 1, max: 4 },
    "2": { min: 5, max: 11 },
    "3": { min: 12, max: 20 },
    "4": { min: 21, max: 28 },
    "5": { min: 29, max: 37 },
    "6": { min: 38, max: 47 },
    "7": { min: 48, max: 56 },
    "8": { min: 57, max: 64 },
    "9": { min: 65, max: 70 },
    "10": { min: 71, max: 73 }
}

const gangnamQrMapping = {
    "1": { min: 1, max: 10 },
    "2": { min: 11, max: 19 },
    "3": { min: 20, max: 29 },
    "4": { min: 30, max: 39 },
    "5": { min: 40, max: 51 },
    "6": { min: 52, max: 55 },
    "7": { min: 56, max: 61 },
    "8": { min: 62, max: 69 },
    "9": { min: 70, max: 75 }
}

const daechi22QrMapping = {
    "1": { min: 101, max: 110 },
    "2": { min: 111, max: 120 },
    "3": { min: 121, max: 129 },
    "4": { min: 130, max: 136 },
    "5": { min: 137, max: 146 },
    "6": { min: 147, max: 156 },
    "7": { min: 157, max: 164 },
    "8": { min: 165, max: 172 },
    "9": { min: 173, max: 178 },
    "10": { min: 179, max: 184 }
}

const daechi3QrMapping = {
    "1": { min: 201, max: 210 },
    "2": { min: 211, max: 220 },
    "3": { min: 221, max: 229 },
    "4": { min: 230, max: 236 },
    "5": { min: 237, max: 242 },
    "6": { min: 243, max: 248 },
    "7": { min: 249, max: 252 },
    "8": { min: 253, max: 260 },
    "9": { min: 261, max: 266 },
    "10": { min: 267, max: 273 }
}

const songdo_fixedQrMapping = {
"2" : {min : 1, max : 14},
"3" : {min : 15, max : 28},
"4" : {min : 29, max : 42},
"5" : {min : 43, max : 56},
"6" : {min : 57, max : 70},
"7" : {min : 71, max : 84},
"8" : {min : 85, max : 98},
}

const molipQrMapping = {
    "1" : {min : 1, max : 5},
    "2" : {min : 6, max : 14},
    "3" : {min : 15, max : 24},
    "4" : {min : 25, max : 34},
    "5" : {min : 35, max : 50},
    "6" : {min : 51, max : 62},
    "7" : {min : 63, max : 74},
    "8" : {min : 75, max : 85},
    "9" : {min : 86, max : 105},
}

const bundangQrMapping = {
    "1": { min: 1, max: 9 },
    "2": { min: 10, max: 18 },
    "3": { min: 19, max: 28 },
    "4": { min: 29, max: 38 },
    "5": { min: 39, max: 48 },
    "6": { min: 49, max: 57 },
    "7": { min: 58, max: 67 },
    "8": { min: 68, max: 77 },
    "9": { min: 78, max: 82 },
    "10": { min: 83, max: 85 },
    "11": { min: 86, max: 93 },
    "12": { min: 94, max: 101 },
    "13": { min: 102, max: 108 },
    "14": { min: 109, max: 116 },
    "15": { min: 117, max: 124 },
    "16": { min: 125, max: 132 },
    "17": { min: 133, max: 139 },
    "18": { min: 140, max: 146 }
}

const songpaQrMapping = {
    "1" : {min : 1, max : 9},
    "2" : {min : 10, max : 19},
    "3" : {min : 20, max : 29},
    "4" : {min : 30, max : 37},
    "5" : {min : 38, max : 45},
    "6" : {min : 46, max : 57},
    "7" : {min : 58, max : 65},
    "8" : {min : 66, max : 73},
    "9" : {min : 74, max : 80},
    "10" : {min : 81, max : 88},
    "11" : {min : 89, max : 96},
}

const ubaseQrMapping = {
    "1" : {min : 1, max : 18},
    "2" : {min : 19, max : 34},
    "3" : {min : 35, max : 49},
    "4" : {min : 50, max : 65},
}

const getLQrMapping = {
    "2" : {min : 127, max : 130},
    "3" : {min : 119, max : 126},
    "4" : {min : 111, max : 118},
    "5" : {min : 107, max : 110},
    "6" : {min : 101, max : 106},
    "7" : {min : 201, max : 211},
    "8" : {min : 212, max : 219},
    "9" : {min : 220, max : 223},
    "12" : {min : 339, max : 343},
    "13" : {min : 333, max : 338},
    "14" : {min : 327, max : 332},
    "15" : {min : 321, max : 326},
    "16" : {min : 315, max : 320},
    "17" : {min : 301, max : 314},
}

const daeguQrMapping = {
    "1":  { min: 1,   max: 6   },
    "2":  { min: 7,   max: 18  },
    "3":  { min: 19,  max: 30  },
    "4":  { min: 31,  max: 41  },
    "5":  { min: 42,  max: 53  },
    "6":  { min: 54,  max: 65  },
    "7":  { min: 66,  max: 76  },
    "8":  { min: 77,  max: 81  },
    "9":  { min: 82,  max: 87  },
    "10": { min: 88,  max: 99  },
    "11": { min: 100, max: 111 },
    "12": { min: 112, max: 123 },
    "13": { min: 124, max: 133 },
    "14": { min: 134, max: 145 },
    "15": { min: 146, max: 156 }
  };

  const lionQrMapping = {
    "1" : {min : 1, max : 15},
    "3" : {min : 16, max : 30},
    "4" : {min : 31, max : 37},
    "5" : {min : 38, max : 51},
    "7" : {min : 52, max : 66},
    "8" : {min : 67, max : 73}
  }

  const gangnam2QrMapping = {
    "1" : { min :1, max : 7},
    "2" : { min : 8, max : 16},
    "3" : { min : 17, max : 26},
    "4" : { min :27, max : 36},
    "5" : { min : 37, max : 40},
    "6" : { min : 41, max :48},
    "7" : { min : 49, max : 55 },
    "8" : { min : 56, max :63 },
    "9" : { min : 64, max : 67 }
  }

  const gimpoQrMapping = {
  "1":  { min: 1,   max: 14 },
  "2":  { min: 15,  max: 25 },
  "3":  { min: 26,  max: 39 },
  "4":  { min: 40,  max: 51 },
  "5":  { min: 52,  max: 63 },
  "6":  { min: 64,  max: 68 },
  "7":  { min: 69,  max: 76 },
  "8":  { min: 77,  max: 83 },
  "9":  { min: 84,  max: 91 },
  "10": { min: 92,  max: 98 },
  "11": { min: 99,  max: 105 },
  "12": { min: 106, max: 113 },
  "13": { min: 114, max: 116 },
  "14": { min: 174, max: 177 },
  "15": { min: 164, max: 173 },
  "16": { min: 155, max: 163 },
  "17": { min: 146, max: 154 },
  "18": { min: 136, max: 145 },
  "19": { min: 127, max: 135 },
  "20": { min: 117, max: 126 }
};

const sinchonQrMapping = {
  "1":  { min: 1,   max: 12 },
  "2":  { min: 13,  max: 26 },
  "3":  { min: 27,  max: 38 },
  "4":  { min: 39,  max: 50 },
  "5":  { min: 51,  max: 64 },
  "6":  { min: 65,  max: 76 },
  "7":  { min: 77,  max: 89 },
  "8":  { min: 90,  max: 104 },
  "9":  { min: 105,  max: 117 },
  "10": { min: 118, max: 131 },
  "11": { min: 132, max: 144 },
  "12": { min: 145, max: 154 },
//   "13": { min: 151, max: 154 }
};

const gangdongQrMapping = {
  "1": { min: 1,   max: 20 },
  "2": { min: 21,  max: 40 },
  "3": { min: 41,  max: 59 },
  "4": { min: 60,  max: 79 },
  "5": { min: 80,  max: 98 },
  "6": { min: 99,  max: 118 },
  "7": { min: 119, max: 135 },
  "8": { min: 136, max: 147 },
  "9": { min: 148, max: 154 }
};

const hanamQrMapping = {
  "1":  { min: 1,   max: 9 },
  "2":  { min: 10,  max: 19 },
  "3":  { min: 20,  max: 29 },
  "4":  { min: 30,  max: 38 },
  "5":  { min: 39,  max: 48 },
  "6":  { min: 49,  max: 58 },
  "7":  { min: 59,  max: 67 },
  "8":  { min: 68,  max: 72 },
  "9":  { min: 73,  max: 82 },
  "10": { min: 83,  max: 92 },
  "11": { min: 93,  max: 101 },
  "12": { min: 102, max: 111 },
  "13": { min: 112, max: 121 },
  "14": { min: 122, max: 126 }
};

const centumQrMapping = {
  "1":  { min: 1,   max: 3   },  // 좌: 1~3
  "2":  { min: 4,   max: 9   },  // 좌: 4~6, 7~9
  "3":  { min: 10,  max: 15  },  // 좌: 10~12, 13~15
  "4":  { min: 16,  max: 21  },  // 좌: 16~18, 19~21
  "5":  { min: 22,  max: 30  },  // 우: 22~25, 26~30
  "6":  { min: 31,  max: 40  },  // 우: 31~35, 36~40
  "7":  { min: 41,  max: 49  },  // 우: 41~44, 45~49
  "8":  { min: 50,  max: 59  },  // 우: 50~54, 55~59
  "9":  { min: 60,  max: 68  },  // 우: 60~64, 65~68
  "10": { min: 69,  max: 78  },  // 우: 69~73, 74~78
  "11": { min: 79,  max: 88  },  // 우: 79~83, 84~88
  "12": { min: 89,  max: 102 },  // 하단좌: 89~95, 96~102
  "13": { min: 103, max: 116 },  // 하단좌: 103~109, 110~116
  "14": { min: 117, max: 122 }   // 하단좌: 117~122
};

const dongtanQrMapping = {
  "1": { min: 1,   max: 16  },  // 1행(1~8) + 2행(9~16)
  "2": { min: 17,  max: 32  },  // 3행(17~24) + 4행(25~32)
  "3": { min: 33,  max: 48  },  // 5행(33~40) + 6행(41~48)
  "4": { min: 49,  max: 62  },  // 7행(49~55) + 8행(56~62)  ← 14석
  "5": { min: 63,  max: 76  },  // 9행(63~69) + 10행(70~76)  ← 14석
  "6": { min: 77,  max: 90  },  // 11행(77~83) + 12행(84~90) ← 14석
  "7": { min: 91,  max: 108 }   // 13행(91~98) + 14행(99~108) ← 18석
};


export const qrSeatData : any = {
    gangnam: gangnamQrMapping,
    daechi: daechiQrMapping,
    daechi2: daechi22QrMapping,
    daechi3: daechi3QrMapping,
    songdo_fixed : songdo_fixedQrMapping,
    molip : molipQrMapping,
    bundang : bundangQrMapping,
    songpa : songpaQrMapping,
    ubase : ubaseQrMapping,
    getL : getLQrMapping,
    daegu : daeguQrMapping,
    lion : lionQrMapping,
    gangnam2 : gangnam2QrMapping,
    gimpo : gimpoQrMapping,
    sinchon : sinchonQrMapping,
    gangdong : gangdongQrMapping,
    hanam : hanamQrMapping,
    centum : centumQrMapping,
    dongtan : dongtanQrMapping
}

// export const patrolTimes = {
//     sunbae: [
//         {
//             class: 1,
//             time: ["8:00", "8:20", "8:40"]
//         },
//         {
//             class: 2,
//             time: ["9:00", "9:20", "9:40", "10:00"]
//         },
//         {
//             class: 3,
//             time: ["10:30", "10:50", "11:10", "11:30"]
//         },
//         {
//             class: 4,
//             time: ["13:00", "13:20", "13:40", "14:00"]
//         },
//         {
//             class: 5,
//             time: ["14:30", "14:50", "15:10", "15:30"]
//         },
//         {
//             class: 6,
//             time: ["16:00", "16:20", "16:40", "17:00"]
//         },
//         {
//             class: 7,
//             time: ["18:30", "18:50", "19:10"]
//         },
//         {
//             class: 8,
//             time: ["19:45", "20:05", "20:25"]
//         },
//         {
//             class: 9,
//             time: ["21:00", "21:20", "21:40"]
//         },
//     ],
//     mom : [
//         {
//             class : 1,
//             time : ["8:00", "8:20", "8:40"]
//         },
//         {
//             class : 2,
//             time : ["9:00", "9:20", "9:40", "10:00"]
//         },
//         {
//             class : 3,
//             time : ["10:20", "10:40", "11:00", "11:20", "11:40"]
//         },
//         {
//             class : 4,
//             time : ["13:00", "13:20", "13:40", "14:00"]
//         },
//         {
//             class : 5,
//             time : ["14:20", "14:40", "15:00", "15:20", "15:40"]
//         },
//         {
//             class : 6,
//             time : ["16:00", "16:20", "16:40"]
//         },
//         {
//             class : 7,
//             time : ["18:00", "18:20", "18:40", "19:00"]
//         },
//         {
//             class : 8,
//             time : ["19:20", "19:40", "20:00"]
//         },
//         {
//             class : 9,
//             time : ["20:20", "20:40", "21:00"]
//         },
//         {
//             class : 10,
//             time : ["21:20", "21:40", "22:00"]
//         },
//         {
//             class : 11,
//             time : ["22:20", "22:40", "23:00"]
//         },
//         {
//             class : 12,
//             time : ["23:20", "23:40"]
//         }
//     ]
// }


